import type { IconProps } from './../../models/icon';

export function ParcelIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          d="M0.856934 7.71432L3.42836 2.76004C3.70558 2.20164 4.1298 1.72941 4.65538 1.39412C5.18096 1.05883 5.78801 0.873196 6.41122 0.857178H17.5884C18.2262 0.857515 18.8513 1.03579 19.3935 1.37194C19.9356 1.7081 20.373 2.18882 20.6569 2.76004L23.1426 7.71432"
        />
        <path
          fill={secondaryColor}
          d="M0.856934 7.71423H23.1426V21.4285C23.1426 21.8831 22.962 22.3193 22.6405 22.6407C22.3191 22.9621 21.883 23.1428 21.4284 23.1428H2.57122C2.11656 23.1428 1.68053 22.9621 1.35904 22.6407C1.03755 22.3193 0.856934 21.8831 0.856934 21.4285V7.71423Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12 0.857178V7.71432"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M14.5713 18.8572H18.857"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M0.856934 7.71423H23.1426V21.4285C23.1426 21.8831 22.962 22.3193 22.6405 22.6407C22.3191 22.9621 21.883 23.1428 21.4284 23.1428H2.57122C2.11656 23.1428 1.68053 22.9621 1.35904 22.6407C1.03755 22.3193 0.856934 21.8831 0.856934 21.4285V7.71423Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M0.856934 7.71432L3.42836 2.76004C3.70558 2.20164 4.1298 1.72941 4.65538 1.39412C5.18096 1.05883 5.78801 0.873196 6.41122 0.857178H17.5884C18.2262 0.857515 18.8513 1.03579 19.3935 1.37194C19.9356 1.7081 20.373 2.18882 20.6569 2.76004L23.1426 7.71432"
        />
      </g>
    </svg>
  );
}
